var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 7.5H3.333v1.667H5V7.5zm3.333 0H6.667v1.667h1.666V7.5zm3.334 0H10v1.667h1.667V7.5zm1.666-5.833H12.5V0h-1.667v1.667H4.167V0H2.5v1.667h-.833A1.66 1.66 0 0 0 .008 3.333L0 15c0 .917.742 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V3.333c0-.916-.75-1.666-1.667-1.666zm0 13.333H1.667V5.833h11.666V15z"
})));
export default SvgCalendar;